import React from "react";
import Weather from "./Weather";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="New York" />

        <footer>
          This project was coded by{" "}
          <a
            href="https://en.wikipedia.org/wiki/Ukraine"
            target="_blank"
            rel="noopener noreferrer"
          >
            Hanna Basista
          </a>{" "}
          and is{" "}
          <a
            href="https://github.com/Hanna-sheCodes/react-weather-app"
            target="_blank"
            rel="noopener noreferrer"
          >
            open-sourced on GitHub
          </a>{" "}
          and{" "}
          <a
            href="https://frabjous-duckanoo-9e013f.netlify.app/"
            target="_blank"
            rel="noopener noreferrer"
          >
            hosted on Netlify
          </a>
        </footer>
      </div>
    </div>
  );
}
